import { render, staticRenderFns } from "./Listar-agendamento.vue?vue&type=template&id=08132e4a&"
import script from "./Listar-agendamento.vue?vue&type=script&lang=js&"
export * from "./Listar-agendamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports